import request from "@/utils/request";
import { TMPURL } from "./config";

//faq列表
export function apiFaqList(params) {
  return request.get(TMPURL + "/v1/public/faq/listContent", params, true);
}

//faq分类
export function apiFaqTypeList(params) {
  return request.get(TMPURL + "/v1/public/faq/categoryList", params, true);
}

//faq详情
export function apiFaqDetail(params) {
  return request.get(TMPURL + "/v1/public/faq/detailContent", params, true);
}

//faq热门问题
export function apiFaqHotList(params) {
  return request.get(TMPURL + "/v1/public/faq/faqHotList", params);
}

//faq是否有用
export function apiFaqUseful(params) {
  return request.post(
    TMPURL + "/v1/public/faq/usefulContent",
    params,
    true,
    true
  );
}
